// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/scritture-contabili?societaId=&registroId=&causaleId=&nominativoId=&stato=&dataDal=&dataAl=&q=',
    requestBody: null,
    response: '{ success: true, data: [{ id, registroContabile, numero, anno, data, causale, sezionaleIva, nominativo, descrizione, importoTotale, stato }] }'
  },
  {
    method: 'GET',
    endpoint: '/api/registri-contabili?societaId=',
    requestBody: null,
    response: '{ success: true, data: [...] }'
  },
  {
    method: 'GET',
    endpoint: '/api/causali-contabili?societaId=',
    requestBody: null,
    response: '{ success: true, data: [...] }'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi?societaId=',
    requestBody: null,
    response: '[{ id, codice, ragioneSociale, nome, cognome }]'
  },
  {
    method: 'DELETE',
    endpoint: '/api/scritture-contabili/:id',
    requestBody: null,
    response: '{ success: true }'
  },
  {
    method: 'PATCH',
    endpoint: '/api/scritture-contabili/:id/storna',
    requestBody: '{ data }',
    response: '{ success: true, data: { id, numero, anno } }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
